<script lang="ts">
    import CN from "classnames";

    import EmptyElement from "@components/EmptyElement.svelte";

    export let ratio: number;
    let className: string | null = null;
    export { className as class };
    $: paddingTop = (1 / ratio) * 100;
</script>

<div
    style={`--gw-image-skeleton-pt: ${paddingTop}%;`}
    class={CN("gw-image-skeleton", className)}
>
    <EmptyElement />
</div>

<style>
    .gw-image-skeleton {
        position: relative;
        max-width: 100%;
        max-height: 100%;
        padding-top: var(--gw-image-skeleton-pt);
        overflow: hidden;
        background-color: var(--gw-image-skeleton-backdrop-color, #eee);
    }
</style>
